import React from "react";
import "../styles/Filters.css";

const FiltersPanel = ({ filters, setFilters, filtersOpen }) => {

const toggleAmenity = (amenity) => {
    setFilters((prev) => ({
      ...prev,
      amenities: {
        ...prev.amenities,
        [amenity]: !prev.amenities[amenity],
      },
    }));
  };


  const bedroomLevels = ["Studio", "1", "2", "3+"];
  const bathroomLevels = ["1", "1.5", "2", "2.5", "3+"];

  const handleBedroomClick = (index) => {
    // If clicking the same section, do nothing.
    if (index === filters.bedrooms) return;
    setFilters((prev) => ({
      ...prev,
      bedrooms: index,
    }));
  };
  
  const formatPrice = (price) => price.toLocaleString("en-US");
  
  const handleBathroomClick = (index) => {
    setFilters((prev) => ({
      ...prev,
      bathrooms: bathroomLevels[index],
    }));
  };
  
    const getBedroomLabel = (index) => {
    switch(index) {
      case 0:
        return "Studio";
      case 1:
        return "1 Bdr";
      case 2:
        return "2 Bdr";
      case 3:
        return "3+ Bdr";
      default:
        return "";
    }
  };
  

  
  return (
    <div className={`filters-panel ${filtersOpen ? "open" : "closed"}`}>
      <h3 className="filters-title">Refine Your Search</h3>

      {/* Price Range Filter */}
      <div className="filter-section">
        <label>Price Range: ${formatPrice(filters.priceMin)} - ${formatPrice(filters.priceMax)}</label>
        
        <div className="price-slider" style={{
          "--min-position": ((filters.priceMin - 500) / (10000 - 500)) * 100,
          "--max-position": ((filters.priceMax - 500) / (10000 - 500)) * 100
        }}>
          {/* Price Track */}
          <div className="slider-track"></div>
          <div className="slider-range"></div>

          {/* Min Price Handle */}
          <input
            type="range"
            className="min-slider"
            min="500"
            max="10000"
            step="50"
            value={filters.priceMin}
            onChange={(e) => {
              const newMin = Math.min(Number(e.target.value), filters.priceMax - 150);
              setFilters((prev) => ({ ...prev, priceMin: newMin }));
            }}
          />

          {/* Max Price Handle */}
          <input
            type="range"
            className="max-slider"
            min="500"
            max="10000"
            step="50"
            value={filters.priceMax}
            onChange={(e) => {
              const newMax = Math.max(Number(e.target.value), filters.priceMin + 150);
              setFilters((prev) => ({ ...prev, priceMax: newMax }));
            }}
          />
        </div>
      </div>
      {/* Bedrooms and Bathrooms Filter */}
		<div className="filter-section">
			<label>Bedrooms (Minimum)</label>
			<div
			  className="fill-bar"
			  onClick={(e) => {
				const rect = e.currentTarget.getBoundingClientRect();
				const clickX = e.clientX - rect.left;
				const currentIndex = filters.bedrooms;
				const newIndex = Math.floor(
				  (clickX / rect.width) * bedroomLevels.length
				);
				if (newIndex !== currentIndex) {
				  handleBedroomClick(newIndex);
				}
			  }}
			>
			  {bedroomLevels.map((level, index) => {
				const currentIndex = filters.bedrooms;
				const isFilled = index >= currentIndex;
				const showLabel = true;
				return (
				  <div
					key={level}
					className={`fill-box ${isFilled ? "filled" : ""}`}
					onClick={() => handleBedroomClick(index)}
				  >
					{showLabel && (
					  <span className="fill-label">{getBedroomLabel(index)}</span>
					)}
				  </div>
				);
			  })}
			</div>
		  </div>

		
		
      <div className="filter-section">
        <label>Bathrooms (Minimum)</label>
        <div className="fill-bar">
          {bathroomLevels.map((label, index) => (
            <div
              key={label}
              className={`fill-box ${index >= bathroomLevels.indexOf(filters.bathrooms) ? "filled" : ""}`}
              onClick={() => handleBathroomClick(index)}
            >
              {label}
            </div>
          ))}
        </div>
      </div>

      {/* Amenities Filter */}
      <div className="filter-section">
        <label>Amenities</label>
        <div className="amenities-checkboxes">
          {Object.keys(filters.amenities).map((amenity) => (
            <button
              key={amenity}
              className={filters.amenities[amenity] ? "active" : ""}
              onClick={() => toggleAmenity(amenity)}
            >
              {amenity.charAt(0).toUpperCase() + amenity.slice(1)}
            </button>
          ))}
        </div>
      </div>

      {/* Apply Filters Button */}
    </div>
  );
};

export default FiltersPanel;
